import { useCallback } from 'react';
import { useQueryClient } from 'react-query';
import { ProjectId } from 'api/models';
import { ProjectAPI } from 'api/project';
import { getProjectDetailQueryKey } from 'queries/common';
import { ALL_PROJECTS_QUERY_KEY } from 'queries/constants';

interface Result {
  enableAutoAllocation: (projectId: number) => void;
  disableAutoAllocation: (projectId: number) => void;
}
export const useAutoAllocationApiManager = (): Result => {
  const queryClient = useQueryClient();

  const changeAutoAllocation = useCallback(
    (projectId: number, autoAllocation: boolean) => {
      ProjectAPI.updateProject(projectId, { autoAllocation }).then(
        async (response) => {
          await queryClient.setQueryData(
            getProjectDetailQueryKey(ProjectId(projectId)),
            response,
          );
          await queryClient.invalidateQueries(ALL_PROJECTS_QUERY_KEY);
        },
      );
    },
    [queryClient],
  );
  const enableAutoAllocation = useCallback(
    (projectId: number) => {
      changeAutoAllocation(projectId, true);
    },
    [changeAutoAllocation],
  );
  const disableAutoAllocation = useCallback(
    (projectId: number) => {
      changeAutoAllocation(projectId, false);
    },
    [changeAutoAllocation],
  );

  return {
    enableAutoAllocation,
    disableAutoAllocation,
  };
};
